module.exports = __webpack_public_path__ + "static/media/alert.cae96303.svg";